(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('vts', {
        templateUrl: 'views/components/views/vts/vts.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'vtsService', 'ttGridFactory', 'modalService', function (stateService, vtsService, ttGridFactory, modalService ) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;

            vm.model = {
                gridVtReady: false,
                gridVtLangReady: false,
                gridVtLinkReady: false,
                setting: {}
            };

            vm.gridVt = new ttGridFactory({
                rememberId: 'w_vts_vt_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'vts_new',
                text: 'vts_new',
                func: () => stateService.go('vt', { vt_keyno: '0' }),
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true
            },{
                name: 'import_from_disc',
                text: 'import_from_disc',
                func: () => importVtFromDisc(),
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true,
                disabled: function () {
                    if (vm.model.setting.dev > '0') {
                        return false;
                    } else {
                        return 'hidden';
                    }
                }

            }]).setOptionFunc((data) => optionFuncVt(data.data));

            function optionFuncVt(data) {
                vm.model.setting.vt_keyno = data.clickedCell.dataItem.vt_keyno;

                loadGridVtLang(vm.model.setting.vt_keyno);
                loadGridVtLink(vm.model.setting.vt_keyno);
            }

            vm.gridVtLang = new ttGridFactory({
                rememberId: 'w_vts_vtlang_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            });
            
            vm.gridVtLink = new ttGridFactory({
                rememberId: 'w_vts_vtlink_grid',
                kendo: {
                    height: null,
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'vtlink_new',
                text: 'vtlink_new',
                func: () => {
                    stateService.go('vtlink', {
                        vt_keyno: vm.model.setting.vt_keyno,
                        vtlink_keyno: '0'
                    });
                },
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true,
                disabled: function () {
                    if (vm.model.setting.vt_keyno > 0) {
                		return false;
                	} else {
                		return 'hidden';
                	}
                }
            }]);
            
            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await vtsService.getSetting())[0];

                loadGridVtLang();
                loadGridVtLink();
            }

            async function importVtFromDisc() {

                let result = await vtsService.importVtFromDisc();
                console.log('result: ',result)
                if (result[0].errorcode !== '0') {
                    modalService.show({
                        type: 'danger',
                        title: 'Varsel',
                        message: result[0].errormessage,
                        buttons: [{
                            label: 'OK',
                            cssClass: 'btn-danger',
                            action: function (dialogItself) {
                                dialogItself.close();
                            }
                        }]
                    });
                }

                vm.gridVt.gridfunc.read();
            }


            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGridVt() {
                vm.gridVt.dataTask.loadData = {
                    method: 3786,
                    parameters: {}
                };

                vm.model.gridVtReady = true;

                if (vm.gridVt.gridfunc !== null) vm.gridVt.gridfunc.read();
            }

            async function loadGridVtLang() {
                vm.gridVtLang.dataTask.loadData = {
                    method: 3787,
                    parameters: { vt_keyno: vm.model.setting.vt_keyno }
                };

                vm.model.gridVtLangReady = true;

                if (vm.gridVtLang.gridfunc !== null) vm.gridVtLang.gridfunc.read();
            }

            async function loadGridVtLink() {
                vm.gridVtLink.dataTask.loadData = {
                    method: 3788,
                    parameters: { vt_keyno: vm.model.setting.vt_keyno }
                };

                vm.model.gridVtLinkReady = true;

                if (vm.gridVtLink.gridfunc !== null) vm.gridVtLink.gridfunc.read();
            }


            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadGridVt();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
